import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine,
} from "recharts";

const fmtDate = (d) =>
  new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

/**
 * Risk burn-down — planned (linear, target trajectory) vs actual residual exposure.
 * `series` = [{ date, planned, actual }]. `target` draws a goal reference line.
 */
export const BurndownChart = ({ series = [], target, height = 260, label = "Residual exposure" }) => {
  if (!series.length) return null;
  return (
    <div data-testid="burndown-chart" style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <LineChart data={series} margin={{ top: 10, right: 16, left: 4, bottom: 18 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#00000010" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: "#6b6b78" }}
            tickFormatter={fmtDate}
            label={{ value: "Timeline", position: "insideBottom", offset: -8, fontSize: 11, fill: "#9a9aa6" }}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#6b6b78" }}
            width={44}
            allowDecimals={false}
            label={{ value: label, angle: -90, position: "insideLeft", fontSize: 10, fill: "#9a9aa6" }}
          />
          <Tooltip
            formatter={(v, name) => [v, name === "actual" ? "Actual" : "Planned"]}
            labelFormatter={(l) => new Date(l).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
            contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #00000012" }}
          />
          <Legend
            wrapperStyle={{ fontSize: 11, paddingTop: 6 }}
            iconSize={10}
            iconType="plainline"
            formatter={(v) => (v === "actual" ? "Actual" : "Planned")}
          />
          {target != null && (
            <ReferenceLine y={target} stroke="#16a34a" strokeDasharray="5 4"
              label={{ value: `Target ${target}`, fontSize: 10, fill: "#16a34a", position: "insideTopRight" }} />
          )}
          <Line type="monotone" dataKey="planned" stroke="#a179fa" strokeWidth={2}
            strokeDasharray="6 4" dot={false} />
          <Line type="monotone" dataKey="actual" stroke="#7737F6" strokeWidth={2.5}
            dot={{ r: 3 }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
